const dubai = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Asia/Dubai",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hourCycle: "h23",
});

/**
 * DBCO-0059 - an ISO instant as a `Date` whose local fields read the Asia/Dubai wall clock: the form the date-time pickers hold and
 * `convertUaeToUtc` turns back into the instant.
 */
export const uaeWallClock = (iso: string | null | undefined): Date | null => {
  if (!iso) {
    return null;
  }
  const instant = new Date(iso);
  if (Number.isNaN(instant.getTime())) {
    return null;
  }
  const parts = Object.fromEntries(
    dubai.formatToParts(instant).map((part) => [part.type, part.value]),
  );
  return new Date(
    Number(parts.year),
    Number(parts.month) - 1,
    Number(parts.day),
    Number(parts.hour),
    Number(parts.minute),
    Number(parts.second),
  );
};
